import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import * as React from "react";

type Props = PageProps;
const UserAccountRequestProcessPage: React.FC<Props> = ({ id}) => {

    return (
        <Page>
              <Zone contentId={id} zoneName="Content0" />
        </Page>
    );
}

const pageModule: PageModule = {
    component: UserAccountRequestProcessPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "MyProfilePage" instead of this constant.
 */
export const UserAccountRequestProcessPageContext = "UserAccountRequestProcessPage";
